module.exports = __webpack_public_path__ + "img/Alien_symbol_7.9e511f4b.png";